import { Component, TemplateRef, OnInit, ViewEncapsulation, ViewChild, Input, Output, EventEmitter, AfterViewInit, Renderer2, ChangeDetectorRef } from '@angular/core';
import { OrderService } from '@app/cp/shared/services/order.service';
import { GlobalsService } from '@app/cp/shared/services/globals.service';
import { Subscription } from 'rxjs';
import { SelectionEvent, ColumnComponent } from '@progress/kendo-angular-grid';
import { CommonFunctions } from '@app/cp/shared/static/common-functions';
import { UntypedFormGroup, UntypedFormControl } from '@angular/forms';
import { BaseGridEditLineComponent } from '@app/cp/shared/base-components/base-grid-editline.component';
import { OrderBillPaymentsBus } from '@app/cp/shared/models/OrderBillPaymentsBus';
import { FeatureFlagService } from "@app/cp/shared/services/feature-flag.service";

@Component({
    selector: 'bill-payments',
    templateUrl: './bill-payments.component.html',
    styleUrls: ['./bill-payments.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class BillPaymentsComponent extends BaseGridEditLineComponent<OrderBillPaymentsBus, null, OrderService>  {

    constructor(globals: GlobalsService, renderer: Renderer2, cd: ChangeDetectorRef, svc_data: OrderService, featureFlagService: FeatureFlagService) {
    super(globals, renderer, cd, featureFlagService);
        this.svc_data = svc_data;
        this.disableCpSearchDialog();
        this.className = "OrderBillPaymentsBus";
    }
    createForm() {
        this.editForm = new UntypedFormGroup({
            'orderBillPaymentId': new UntypedFormControl(),
            'orderBillId': new UntypedFormControl(),
            'amountPaid': new UntypedFormControl(),
            'paidById': new UntypedFormControl(),
            'datePaid': new UntypedFormControl(),
            'refNo': new UntypedFormControl(),
            'memo': new UntypedFormControl(),
            'ccaccountId': new UntypedFormControl(),
            'released': new UntypedFormControl()
        });

    }
    setForm() {
        this.editForm.patchValue({
            orderBillPaymentId: this.selectedData.orderBillPaymentId,
            orderBillId: this.selectedData.orderBillId,
            amountPaid: this.selectedData.amountPaid,
            paidById: this.selectedData.paidById,
            datePaid: this.selectedData.datePaid,
            refNo: this.selectedData.refNo,
            memo: this.selectedData.memo,
            ccaccountId: this.selectedData.ccaccountId,
            released: this.selectedData.released
        });
    }
}
